module.exports = __webpack_public_path__ + "media/images/us-flag-5e3d790f617c430deea2e890c1a455f4.svg";